import type {IRootMachineSnapshot} from '../machines/rootMachine/rootMachine';
import type {IEvent} from '../types/IEvent';
import {format, timezoneName} from '../utils/date';


export const selectMeetingDateTime = (
  state: IRootMachineSnapshot,
  language: string,
) => {
  const eventDetails = state.context.eventDetails as IEvent;
  if (!eventDetails?.event_start) {
    return '';
  }
  const dateTime = format(new Date(eventDetails?.event_start), 'PPPPp', {
    language,
  });
  const timezone = timezoneName(eventDetails?.event_start, language) || '';

  return `${dateTime}, ${timezone}`;
};
